export function SiteFooter() {
  return (
    <footer className="text-muted">
      <div className="container">
        <p>Copyright &copy; {new Date().getFullYear()} Lynn LoPucki</p>
      </div>
    </footer>
  );
}
